import Basic from '@/views/backstage/structure/detail_page/common/BasicStructure'
import Rights from '@/views/backstage/structure/detail_page/common/RightsStructure'
import PhysicalObject from '@/views/backstage/structure/detail_page/common/PhysicalObjectStructure'
import ForestryData from '@/views/backstage/structure/detail_page/common/ForestryDataStructure'

let CultureNaturalLandscapeFields = {
    'category': {
        display: {
            name: '種類',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'category',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['地質','地形','水文','礦物','生態物種','文化'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'era_ad': {
        display: {
            name: '年代(西元)',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'era_ad',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'era_none_ad': {
        display: {
            name: '年代(非西元)',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'era_none_ad',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'area': {
        display: {
            name: '面積',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'area',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'area_unit': {
        display: {
            name: '面積單位',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'area_unit',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'single-select-as-is',
            options: {
                type: 'fixed',
                list: ['平方公尺','公頃'].map(x=>({value:x, label:x})),
                additional: true,
            }
        }
    },
    'bulletin_date': {
        display: {
            name: '公告日期',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'bulletin_date',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'datetime'
        }
    },
    'bulletin_number': {
        display: {
            name: '公告文號',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'bulletin_number',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'evaluation_benchmark': {
        display: {
            name: '評定基準',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'evaluation_benchmark',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'add_reason': {
        display: {
            name: '登錄理由',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'add_reason',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'law_basis': {
        display: {
            name: '法令依據',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'law_basis',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
    'manager_organ': {
        display: {
            name: '所屬主管機關',
            type: 'string',
        },
        source: {
            type: 'db',
            key: 'manager_organ',
            data_type: 'string',
        },
        change: {
            editable: true,
            addable: true,
            type: 'string'
        }
    },
}

let CultureNaturalLandscape = (front_back) => {

    let fields = [
        CultureNaturalLandscapeFields['category'],
        CultureNaturalLandscapeFields['era_ad'],
        CultureNaturalLandscapeFields['era_none_ad'],
        CultureNaturalLandscapeFields['area'],
        CultureNaturalLandscapeFields['area_unit'],
        CultureNaturalLandscapeFields['bulletin_date'],
        CultureNaturalLandscapeFields['bulletin_number'],
        CultureNaturalLandscapeFields['evaluation_benchmark'],
        CultureNaturalLandscapeFields['add_reason'],
        CultureNaturalLandscapeFields['law_basis'],
        CultureNaturalLandscapeFields['manager_organ'],
    ]

    return {
        name: '文化、自然景觀資料',
        type: 'group',
        fields
    }
}

export default (front_back = 'backstage') => {
    
    let candidates = [].concat(
        Basic('culture_natural_landscape', front_back),
        ForestryData('culture_natural_landscape', front_back),
        CultureNaturalLandscape(front_back), 
        Rights('culture_natural_landscape', front_back), 
        PhysicalObject('culture_natural_landscape', front_back))
    
    let fields = candidates.filter( x => x.fields.length > 0)    

    return {
        name: '文化、自然景觀類',
        type: 'group',
        fields
    }    
}  